import React, { useEffect } from 'react';
import { useInView } from 'react-intersection-observer';
import Title from 'components/UI/Title';
import { replaceKeyword } from 'utils';

import * as styles from './BulletsCard.module.scss';

export default function BulletsCard({ cardId, count, countDescription, setActive }) {
  const [inViewRef, inView] = useInView({ threshold: 1 });

  useEffect(() => {
    if (inView && setActive) {
      setActive(cardId);
    }
  }, [inView, cardId, setActive]);

  return (
    <div className={styles.card} id={cardId} ref={inViewRef}>
      <div className={styles.count}>
        <Title tag="p" size="h3">
          {replaceKeyword(count)}
        </Title>
        <p className={styles.countDescription}>{countDescription}</p>
      </div>
    </div>
  );
}
